<div class="flex flex-col gap-[0.1875rem]" (mouseleave)="onCellLeave()">
  @for (row of rows(); track row) {
    <div class="flex gap-[0.1875rem]">
      @for (col of cols(); track col) {
        <button
          type="button"
          class="grid-cell w-[1.25rem] h-[1.25rem] bg-transparent border border-neutral-300 rounded-sm transition-colors duration-200 ease-in-out hover:bg-primary-100 hover:border-[1.5px]! hover:border-primary-400"
          [class.highlighted]="highlightedCells().has(row + '-' + col)"
          (mouseenter)="onCellHover(row, col)"
          (click)="selectSize(row, col)"></button>
      }
    </div>
  }
</div>
<div
  class="mt-lg text-sm text-neutral-600 leading-4 flex justify-between gap-2">
  <div
    class="w-full flex gap-[0.5rem] p-md border border-neutral-300 rounded-md shadow-xs">
    <lib-row-icon iconClass="size-4" />
    <p>
      {{ hoveredRow() }}
    </p>
  </div>
  <div
    class="w-full flex gap-[0.5rem] p-md border border-neutral-300 rounded-md shadow-xs">
    <lib-col-icon iconClass="size-4" />
    <p>
      {{ hoveredCol() }}
    </p>
  </div>
</div>
